import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import MemberCard from '../member-card';
import DisabledOverlay from '../../../components/purchase-dashboard/disabled-overlay';
import Title from '../../title';

class ShortContributors extends Component {
  renderHeading() {
    return (
      <div className="purchase-contributors-heading">
        <Title
          text={
            <FormattedMessage
              id="contributors.short.title"
              defaultMessage="Short contributors"
            />
          }
          name="contributors"
          bigger divider
        />
        <div className="heading pt-4">
          <a href="#solve-issues" onClick={this.props.onSolveIssues} className="float-right">
            <FormattedMessage
              id="contributors.short.resolveIssues"
              defaultMessage="Resolve issues"
            />
          </a>
          <p>
            <FormattedMessage
              id="contributors.short.description"
              defaultMessage="Contributors that need to confirm a larger charge."
            />
          </p>
        </div>
      </div>
    );
  }

  renderMemberCardAsOrganizer(membership) {
    return (
      <MemberCard
        onRemoveMember={this.props.onRemoveMember}
        membership={membership}
        payments={this.props.payments}
        viewAs="organizer"
      />
    );
  }

  renderMemberCardAsInvitee(membership) {
    return (
      <MemberCard
        membership={membership}
        payments={this.props.payments}
        viewAs="invitee"
      />
    );
  }

  renderMemberCards() {
    const { asOrganizer } = this.props;
    const cards = this.props.memberships.map((member) => {
      const key = `member-card-${member.id}`;
      return (
        <div className="contributor-card col-lg-4 col-md-12" key={key}>
          { asOrganizer ? this.renderMemberCardAsOrganizer(member) : this.renderMemberCardAsInvitee(member) }
        </div>
      );
    });

    return (
      <div className="cards row">
        {cards}
      </div>
    );
  }

  renderDisableOverlay() {
    if (this.props.disable) return <DisabledOverlay />;
  }

  render() {
    if (!this.props.memberships.length) return null;

    return (
      <div className="purchase-contributors short container">
        <div className="container">
          {this.renderHeading()}
          {this.renderMemberCards()}
        </div>
        {this.renderDisableOverlay()}
      </div>
    );
  }
}

export default ShortContributors;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/contributors/contributors.short.js